import React from "react";

export function Badge({ children, className, variant = "default", ...props }) {
  const baseClasses = "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2";
  
  const variantClasses = {
    default: "bg-indigo-100 text-indigo-800",
    secondary: "bg-gray-100 text-gray-800",
    success: "bg-green-100 text-green-800",
    warning: "bg-yellow-100 text-yellow-800",
    error: "bg-red-100 text-red-800"
  };
  
  const classes = `${baseClasses} ${variantClasses[variant] || ""} ${className || ""}`;
  
  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
}
